<mat-sidenav-container (backdropClick)="closeSlideBar()">
  <mat-sidenav position="end" [opened]="sideBarOpened" disableClose>
    <router-outlet name="sidebar"></router-outlet>
  </mat-sidenav>
  <mat-sidenav-content id="main">
    <section id="suivi-demandes" class="h-full">
      <h1 class="center">Suivi des demandes</h1>
      <div id="header">
        <div class="flex flex-wrap">
          <mat-form-field class="large">
            <mat-label>Utilisateur/motif/numéro de demande</mat-label>
            <input matInput [formControl]="searchControl"
              placeholder="Saisir la recherche">
            <mat-icon matSuffix class="color">search</mat-icon>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Date de début</mat-label>
            <input matInput [matDatepicker]="picker" [formControl]="searchDateBeginControl"
              placeholder="Format : jj/mm/aaaa">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker panelClass="custom-calendar"></mat-datepicker>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Date de fin</mat-label>
            <input matInput [matDatepicker]="picker2" [formControl]="searchDateEndControl"
              placeholder="Format : jj/mm/aaaa">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2 panelClass="custom-calendar"></mat-datepicker>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Statut</mat-label>
            <mat-select [formControl]="searchStatuControl" multiple placeholder="Sélectionner le(s) statut(s)">
              <mat-option *ngFor="let status of statutList" [value]="status">
                {{ status }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="large">
            <mat-label>Type de demande</mat-label>
            <mat-select [formControl]="searchTypeControl" multiple placeholder="Sélectionner le(s) type(s) de demande">
              <mat-option *ngFor="let type of typeList" [value]="type">
                {{ type }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="orders-multi-client">
            Afficher par Compte Client <mat-slide-toggle class="orders-multi-client-toggle" [checked]="sousComptes"
              (change)="changeSousComptes($event)">compte et sous-compte Client</mat-slide-toggle>
          </div>
        </div>
        <button mat-raised-button color="primary" (click)="export()" hideIfNot="ROLE_DEMANDES_EXTRACT" id="button">Export
          (XLSX)</button>
      </div>
      <article>
        <table mat-table [dataSource]="dataRes">
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td class="list-actions-1" mat-cell *matCellDef="let row"><a (click)="orderDetails(row)">
                <mat-icon matTooltip="Voir plus">visibility</mat-icon>
              </a></td>
          </ng-container>
          <ng-container *ngFor="let column of columns">
            <ng-container matColumnDef="{{column.id}}">
              <th mat-header-cell *matHeaderCellDef>{{ column.libelle }}</th>
              <td mat-cell *matCellDef="let element">
                <span [ngClass]="'state-circle ' + 'state-circle-' + getStatut(element)"
                  *ngIf="column.libelle == 'Statut'"></span>
                {{ element| getData: column | momentFormat : 'DD/MM/YYYY' }}
              </td>
            </ng-container>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </article>
      <article class="no-content" *ngIf="dataRes.data.length == 0 && !load">
        <p>Aucun résultat</p>
      </article>
      <div [hidden]="dataRes.data.length == 0">
        <mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
      </div>
    </section>
  </mat-sidenav-content>
</mat-sidenav-container>